import type { Role } from "../api";
import { ROUTES } from "../shell/routes";
import type { SessionState } from "./types";

/** Les rôles de l'ESN : ceux qui voient tout portefeuille et toute feuille. */
export const ESN_ROLES: readonly Role[] = ["esn_admin", "commercial"];
/** Les rôles d'une entreprise cliente. */
export const COMPANY_ROLES: readonly Role[] = ["admin", "member"];
/**
 * Le consultant a son propre espace : intervenant de l'ESN, il ne voit ni
 * portefeuille, ni tarif, ni entreprise — seulement ses missions et ses
 * feuilles de temps.
 */
export const CONSULTANT_ROLES: readonly Role[] = ["consultant"];

/** Vrai pour un rôle de l'ESN (le consultant n'en est pas). */
export function isEsnRole(role: Role): boolean {
  return ESN_ROLES.includes(role);
}

/**
 * L'écran d'accueil d'une session : l'espace ESN pour l'ESN, le dashboard pour
 * une entreprise, la vitrine pour un anonyme — elle porte les liens vers la
 * connexion et l'inscription, et une URL inconnue sans session mène à la
 * porte d'entrée plutôt qu'au guichet.
 */
export function homeFor(state: SessionState): string {
  if (state.status !== "authenticated") {
    return ROUTES.accueil;
  }
  return homeForRole(state.user.role);
}

/** L'écran d'accueil d'un rôle. */
export function homeForRole(role: Role): string {
  if (role === "consultant") {
    return ROUTES.consultant;
  }
  return isEsnRole(role) ? ROUTES.esnEntreprises : ROUTES.dashboard;
}

/**
 * Filtre une destination mémorisée avant connexion : seul un chemin interne
 * (qui commence par un `/` et pas par `//`) est suivi. Tout autre chose serait
 * une redirection ouverte, le plus vieux des pièges d'écran de connexion.
 */
export function destinationSure(candidate: unknown): string | null {
  if (typeof candidate !== "string" || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return null;
  }
  return candidate;
}
